exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-facial-detail-wrapper[data-v-746f35eb]{display:block}.top-container[data-v-746f35eb]{padding:0 20px 20px;display:flex;flex-direction:row;align-items:center}.success-content[data-v-746f35eb]{font-size:16px;font-weight:500;color:#405fff;display:flex;flex-direction:row;align-items:center}.success-content img[data-v-746f35eb]{width:24px;height:24px}.failure-content[data-v-746f35eb]{margin-left:40px;font-size:16px;font-weight:500;color:#f44;display:flex;flex-direction:row;align-items:center}.failure-content img[data-v-746f35eb]{width:24px;height:24px}.button-export[data-v-746f35eb]{margin-left:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-746f35eb&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UserManage/UserManage/UploadFacialDetail.vue
// module id = 579
// module chunks = 0